import { RouterProvider } from 'react-router';
import { router } from '@/routes';
import { Toaster } from '@/components/ui/sonner';
import { useEffect } from 'react';

export default function App() {
  useEffect(() => {
    if (navigator.storage && navigator.storage.persist) {
      navigator.storage.persist().then(isPersisted => {
        if (isPersisted) {
          console.log('Storage successfully persisted.');
        } else {
          console.log('Storage not persisted. Data may be cleared by the browser under pressure.');
        }
      });
    }
  }, []);
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
    </>
  );
}
